import ChatPreviewIcon from './ChatPreviewIcon';

export default ChatPreviewIcon;
